// src/components/PrintModal.js

import React, { useState, useEffect } from 'react';
import './PrintModal.css';

const PrintModal = ({ isOpen, onClose, onPrint, kitType, actionLoading }) => {
    const [quantity, setQuantity] = useState(24);

    useEffect(() => {
        if (isOpen) {
            setQuantity(24); // Reset to default when modal opens
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handlePrint = () => {
        // The onPrint function now only needs the quantity.
        onPrint(quantity);
    };

    return (
        <div className="GORDPM-modal-overlay">
            <div className="GORDPM-modal-content">
                <div className="GORDPM-modal-header">
                    <h2>Print New Labels for {kitType.Name}</h2>
                    <button onClick={onClose} className="GORDPM-close-btn">×</button>
                </div>
                <div className="GORDPM-form-group">
                    <label htmlFor="quantity">How many new kits and labels to generate?</label>
                    <input
                        id="quantity"
                        type="number"
                        value={quantity}
                        onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
                        min="1"
                        className="GORDPM-input"
                    />
                </div>
                <div className="GORDPM-info">
                    <p>This will generate <strong>{quantity} brand new kit units</strong> and open a print dialog for their labels.</p>
                </div>
                <div className="GORDPM-actions">
                    <button className="GORDPM-btn GORDPM-btn-secondary" onClick={onClose} disabled={actionLoading}>Cancel</button>
                    <button 
                        className="GORDPM-btn GORDPM-btn-primary"
                        onClick={handlePrint}
                        disabled={actionLoading || quantity <= 0}
                    >
                        {actionLoading ? (
                            <>
                                <i className="fas fa-spinner fa-spin"></i> Generating...
                            </>
                        ) : `Generate & Print ${quantity} Labels`}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PrintModal;